import styled from '@emotion/styled';

export const StickyMapContainer = styled.div`
  box-sizing: border-box;
  position: sticky;
  top: var(--sticky-offset);
  height: calc(100vh - var(--sticky-offset));
  padding: 16px 0;
`;
